import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
        
export default function contablegastoReducer(state= initialState.contablegasto, action){
    let newState;
	switch(action.type){
         case types.LOAD_CONTABLEGASTO_LIST_SUCCESS:		
            action.contablegasto.filtroActivo=state.filtroActivo;
            action.contablegasto.filtroActual=state.filtroActual;
            action.contablegasto.showActivos=state.showActivos;
			 action.contablegasto.paginaActual=action.contablegasto.pageable.pageNumber;
			 action.contablegasto.registrosPorPagina=action.contablegasto.size;
            
            return action.contablegasto;

        case types.BORRAR_CONTABLEGASTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contablegasto => contablegasto.id !== action.contablegasto.id)];          
			return newState;    
            
        case types.ACTIVAR_CONTABLEGASTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(contablegasto => contablegasto.id !== action.contablegasto.id)];          
			 return newState;
            
        case types.SET_FILTRO_CONTABLEGASTO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}